import React from 'react';
import { Popover, Card, Button, Form } from 'antd';
import { useTranslation } from 'react-i18next';
import { useForm, FormProvider } from 'react-hook-form';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import FormInput from '../../global/Forms/FormInput';

type VcdbAddConfigPopoverProps = {
  keywords?: string;
  handleSave: (name: string) => Promise<any>;
};

const VcdbAddConfigPopover: React.FC<VcdbAddConfigPopoverProps> = props => {
  const { t } = useTranslation();

  const [popoverVisible, setPopoverVisible] = React.useState(false);

  const validationSchema = Yup.object().shape({
    name: Yup.string().required(t('validation:required')),
  });

  const formMethods = useForm({
    defaultValues: {
      name: props.keywords || '',
    },
    resolver: yupResolver(validationSchema),
    mode: 'onTouched',
  });

  const { handleSubmit, formState, reset } = formMethods;

  React.useEffect(() => {
    if (popoverVisible) reset({ name: props.keywords || '' });
  }, [popoverVisible, props.keywords, reset]);

  const onSubmit = async (values: { name: string }) => {
    try {
      await props.handleSave(values.name);
      setPopoverVisible(false);
    } catch (error) {
      /* empty */
    }
  };

  return (
    <Popover
      open={popoverVisible}
      onOpenChange={visible => {
        setPopoverVisible(visible);
      }}
      overlayClassName="help application_listing__popover"
      placement="bottomLeft"
      destroyTooltipOnHide
      content={
        <Card className="qualifier__value-popover" bordered={false}>
          <FormProvider {...formMethods}>
            <Form layout="vertical" onFinish={handleSubmit(onSubmit)}>
              <FormInput
                name="name"
                label={t('application:vcdbAddCustom')}
                maxLength={100}
                required
                useHookForm
              />
              <div className="flex-col items-end">
                <div>
                  <Button
                    onClick={() => setPopoverVisible(false)}
                    className="drawer-submit__bottom-cancel"
                  >
                    {t('common:cancel')}
                  </Button>
                  <Button
                    type="primary"
                    htmlType="submit"
                    disabled={formState.isSubmitting}
                    loading={formState.isSubmitting}
                  >
                    {t('common:save')}
                  </Button>
                </div>
              </div>
            </Form>
          </FormProvider>
        </Card>
      }
      trigger="click"
    >
      <Button size="small">{t('common:add')}</Button>
    </Popover>
  );
};

export default VcdbAddConfigPopover;
